import React from 'react';
import { fetchWrapper } from '../../APIManager';
const MessagesStateContext = /*#__PURE__*/React.createContext();
const MessagesDispatchContext = /*#__PURE__*/React.createContext();

// This could probably be combined with one of our other contexts

const initialState = {
  message_users: [] // the user data
};

/** REDUCER **/
function MessagesReducer(state, action) {
  switch (action.type) {
    case 'SET_MESSAGE_USERS':
      const newMessageUsers = Array.isArray(action.payload) ? action.payload : [action.payload];
      return {
        ...state,
        message_users: newMessageUsers
      };
    case 'ADD_MESSAGE_USER':
      return {
        ...state,
        message_users: [...state.message_users, action.payload]
      };
    case 'REMOVE_MESSAGE_USER':
      const updatedArr = state.message_users.filter(u => u.username !== action.payload.username);
      return {
        ...state,
        message_users: updatedArr
      };
    case 'RESET_MESSAGE_USERS':
      return {
        ...state,
        message_users: []
      };
    default:
      {
        throw new Error('Unhandled action type caught');
      }
  }
}

/** PROVIDER **/
function MessagesProvider({
  value,
  children
}) {
  const [state, dispatch] = React.useReducer(MessagesReducer, initialState);
  return /*#__PURE__*/React.createElement(MessagesStateContext.Provider, {
    value: state
  }, /*#__PURE__*/React.createElement(MessagesDispatchContext.Provider, {
    value: dispatch
  }, children));
}

/** STATE/DISPATCH HOOKS **/
function useMessagesState() {
  const context = React.useContext(MessagesStateContext);
  if (context === undefined) {
    throw new Error('useMessagesState must be used within a MessagesProvider');
  }
  return context;
}
function useMessagesDispatch() {
  const context = React.useContext(MessagesDispatchContext);
  if (context === undefined) {
    throw new Error('useMessagesDispatch must be used within a MessagesProvider');
  }
  return context;
}
export { MessagesProvider, useMessagesState, useMessagesDispatch };
//# sourceMappingURL=index.js.map